import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { Localization } from '@/app/components/search/common/Localization';

export const RESULT_PAGE_SORT_RESULT = 'RESULT_PAGE_SORT_RESULT';
export const RESULT_PAGE_SORT_RESULT_VERSION = '1.0';

export type ResultPageSortResultParams = {
  searchParams: SearchParams;
  localization: Localization;
};

export type ResultPageSortResultPayload = {
  searchId: string;
  sorting: string;
};

export const createResultPageSortResultPayload = (params: ResultPageSortResultParams): ResultPageSortResultPayload => {
  const { searchParams } = params;
  const searchId = searchParams[URLParameters.SEARCH_ID];
  const sort = searchParams[URLParameters.SORT];
  if (!searchId) throw new Error('searchId not present in searchParams');

  const payload = {
    searchId,
    sorting: sort && sort.toUpperCase(),
  };

  return payload;
};
